import React, { useState } from 'react';
import { Button } from '@themesberg/react-bootstrap';

const StepManager = ({ steps, onStepChange }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      const nextStep = currentStep + 1;
      setCurrentStep(nextStep);
      onStepChange && onStepChange(nextStep);
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      const prevStep = currentStep - 1;
      setCurrentStep(prevStep);
      onStepChange && onStepChange(prevStep);
    }
  };

  return (
    <div className="step-manager">
      <div className="step-content">
        {steps[currentStep].component}
      </div>
      <div className="step-navigation mt-3 d-flex justify-content-between">
        <Button
          variant="dark"
          onClick={handleBack}
          disabled={currentStep === 0}
        >
          &lt; Anterior
        </Button>
        <Button
          variant="primary"
          onClick={handleNext}
          disabled={currentStep === steps.length - 1}
        >
          Siguiente &gt;
        </Button>
      </div>
    </div>
  );
};

export default StepManager; 